import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoWhiteSpace]'
})
export class NoWhiteSpaceDirective {
  constructor(public model: NgControl) {}

  @HostListener('ngModelChange', ['$event']) onInputChange(event): void {
    this.model.valueAccessor.writeValue(event.trim());
  }
}
